class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
    this.closeStickySearchButton = document.querySelector('.header-search-close');
    this.productToShow = this.dataset.productToShow;
    this.searchDetails = this.querySelector('.search_details');
    this.predictiveSearch = this.querySelector('predictive-search')
    this.isOpen = false;

    this.setupEventListeners();
  }
  
  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 500).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('click', this.onDocClick.bind(this));
    if (this.closeStickySearchButton != null) {
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) {
      this.close(true);
      return;
    }
    
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();

    const form = event.currentTarget;
    if (!form.querySelector('[name="type"]')) {
      const typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      typeInput.value = 'product';
      form.appendChild(typeInput);
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) return this.showTrendingAndProducts();

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
        // this.hideTrendingAndProducts();
      };
    })
  }
  
  onKeyup(event) {
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
    };
    event.preventDefault();
    
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';
    
    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
    
  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }
  
  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.updateViewAllLink(searchTerm);
      return;
    }

    const productLimit = Math.max(Number(this.productToShow) || 0, 5);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection&${encodeURIComponent('resources[limit]')}=${productLimit}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        
        return response.text();
      })  
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
        this.updateViewAllLink(searchTerm);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.applySearchUI(this.predictiveSearchResults, this.input.value);
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.setLiveRegionResults();
    this.open();
    this.hideTrendingAndProducts();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('[class^="header-navigation"]').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  
  open() {
    //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }

  showTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 
    this.trendingAndProductsBlock.classList.add('is-show')
    this.trendingAndProductsBlock.classList.remove('hidden');
  }

  hideTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 

    this.trendingAndProductsBlock.classList.remove('is-show')
    this.trendingAndProductsBlock.classList.add('hidden');
  }

  onDocClick(e) {
    const isInModal = this.contains(e.target), $target = e.target

    if (!isInModal || $target.closest('.header-search-popup-close') || $target.matches('.header-search-popup-close') || $target.closest('.header-search-close') || $target.matches('.header-search-close')) {
      this.close();
      this.hideTrendingAndProducts();
    }
  }

  onCloseStickySearchClick() {
    this.close();
    this.hideTrendingAndProducts();
    document.querySelector('body').classList.remove('sticky-search-open');
    document.querySelector('body').classList.remove('sticky-search-menu-open');
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open')
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-custom-open')
  }

  escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  escapeHTML(value) {
    return value.replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[character]);
  }

  highlightTextElement(element, keyword) {
    if (!element || !keyword) return;

    const text = element.dataset.ciSearchText || element.textContent;
    const cleanKeyword = keyword.trim();

    element.dataset.ciSearchText = text;

    if (!cleanKeyword) {
      element.textContent = text;
      return;
    }

    const expression = new RegExp(`(${this.escapeRegExp(cleanKeyword)})`, 'ig');
    element.innerHTML = this.escapeHTML(text).replace(expression, '<span class="ci-search-highlight">$1</span>');
  }

  renderSuggestions(root, keyword) {
    if (!root || !keyword) return;

    const existingSuggestions = root.querySelector('.ci-search-suggestions');
    if (existingSuggestions) existingSuggestions.remove();

    const terms = new Set();
    const cleanKeyword = keyword.trim();
    const normalizedKeyword = cleanKeyword.toLowerCase();

    const addTerm = (value) => {
      const term = value.replace(/\s+/g, ' ').trim();
      if (!term || term.length < 2) return;
      if (term.toLowerCase() === normalizedKeyword && terms.size > 0) return;
      terms.add(term);
    };

    const titleSources = [
      ...root.querySelectorAll('[data-ci-source-title]'),
      ...root.querySelectorAll('.ci-card__title, .card-title')
    ];

    titleSources.forEach((item) => {
      if (terms.size >= 6) return;

      const title = item.textContent.replace(/\s+/g, ' ').trim();
      if (!title) return;

      const words = title.match(/[A-Za-z0-9]+/g) || [];
      const keywordIndex = normalizedKeyword
        ? words.findIndex((word) => word.toLowerCase().includes(normalizedKeyword))
        : -1;

      if (keywordIndex >= 0) {
        const start = Math.max(0, keywordIndex - 1);
        const phrase = words.slice(start, Math.min(words.length, keywordIndex + 3)).join(' ');
        addTerm(phrase);
        return;
      }

      addTerm(words.slice(0, 3).join(' ') || title);
    });

    if (!terms.size && cleanKeyword) addTerm(cleanKeyword);

    if (!terms.size) return;

    const suggestions = document.createElement('div');
    suggestions.className = 'ci-search-suggestions';
    suggestions.innerHTML = '<span class="ci-search-suggestions__label">Suggestions:</span>';

    terms.forEach((term) => {
      const link = document.createElement('a');
      link.href = `${routes.search_url}?q=${encodeURIComponent(term)}*&type=product`;
      link.textContent = term;
      suggestions.appendChild(link);
    });

    const target = root.querySelector('.predictive-search__heading, .ci-search-found-title, .products-grid, .productGrid, .productEmpty');
    if (target) target.insertAdjacentElement('beforebegin', suggestions);

    suggestions.querySelectorAll('a').forEach((link) => this.highlightTextElement(link, cleanKeyword));
  }

  buildMobileDots(grid) {
    if (!grid) return;

    const existingDots = grid.parentElement.querySelector('.ci-search-dots');
    if (existingDots) existingDots.remove();

    const products = grid.querySelectorAll('.product');
    const itemsPerPage = window.matchMedia('(max-width: 1024px)').matches ? 1 : 2;
    const pageCount = Math.ceil(products.length / itemsPerPage);

    if (pageCount <= 1) return;

    const dots = document.createElement('div');
    dots.className = 'ci-search-dots';

    for (let index = 0; index < pageCount; index += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = index === 0 ? 'is-active' : '';
      dot.setAttribute('aria-label', `Go to search result page ${index + 1}`);
      dot.addEventListener('click', () => {
        grid.scrollTo({ left: grid.clientWidth * index, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    }

    grid.insertAdjacentElement('afterend', dots);

    grid.addEventListener('scroll', () => {
      const activeIndex = Math.round(grid.scrollLeft / grid.clientWidth);
      dots.querySelectorAll('button').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }, { passive: true });
  }

  applySearchUI(root, keyword) {
    if (!root) return;

    this.renderSuggestions(root, keyword);
    root.querySelectorAll('.ci-card__title, .card-title').forEach((title) => this.highlightTextElement(title, keyword));
    root.querySelectorAll('.productGrid, .products-grid').forEach((grid) => this.buildMobileDots(grid));
  }

  updateViewAllLink(searchTerm) {
    const qsViewAllLink = document.querySelector('[data-qs-view-all-link]');
    if (!qsViewAllLink) return 

    const linkTotal = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&type=product`
    
    qsViewAllLink.href = linkTotal
    return this.getTotalResults(linkTotal).then(count => {
      qsViewAllLink.innerHTML = qsViewAllLink.innerHTML.replace('()', `(${count})`)
    });
  }

  getTotalResults(url) {
    return fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })  
      .then((text) => {
        const totalCount = new DOMParser().parseFromString(text, 'text/html').querySelector('[id^="SearchSection"]').dataset.searchCount;
        return totalCount
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
}

customElements.define('predictive-search', PredictiveSearch);
